export const urlFetchCalls = {
  get: {
    users: "get_users.php",
    get_transactions: "get_transactions.php",
    graphTransactions: "graphTransactions.php",
    add_friend: "add_friend.php",
    get_friends: "get_friends.php",
    remove_friend:"remove_friend.php",
    change_password:"change_password_request.php",
    create_home:"home/create_home.php",
    get_home_expenses:"home/get_expenses_advance.php",
    add_home_member:"home/add_home_member.php",
    get_home_members:"home/get_home_members.php",
    input_suggestions:"home/input_suggestion.php",
    get_homes:"home/get_homes.php",
    get_dashboard_insights:"home/get_dashboard_insights.php",
    delete_home_expense:"home/delete_home_expense.php",
    delete_home:"home/delete_home.php",
    get_bill_images:"home/get_bill_images.php",
    mcp_oauth_clients:"mcp/api/oauth_clients.php",
    mcp_bearer_token:"mcp/api/bearer_token.php"
  },
  post: {
    signup: "register.php",
    login: "login.php",
    set_transaction: "set_transaction.php",
    approve_transaction: "approve_transaction.php",
    change_status: "change_transaction_state.php",
    get_report: "report_of_selected_transactions.php",
    make_paid: "make_paid.php",
    delete_transaction: "delete_transaction.php",
    reset_password:"reset_password.php",
    change_password:"change_password_request.php",
    add_home_expenses:"home/add_home_expenses.php", 
    remove_home_members:"home/remove_home_members.php",
    mcp_oauth_token:"mcp/api/oauth_token.php",
    mcp_bearer_token:"mcp/api/bearer_token.php",
    upload_bill_images:"home/upload_bill_images.php",
    verify_email:"verify_email.php",
    resend_otp:"resend_otp.php"
  },
};

export const categoryOptions = [
  { value: "kiraya_bijli_pani", label: "🏠 Kiraya & Bill (Bijli, Pani, Gas, Kuda)" },
  { value: "rashan_ghar", label: "🛒 Rashan & Ghar Ka Saman" },
  { value: "khana_nashta", label: "🍽️ Bahar Khana (Restaurant, Fast Food, Chai)" },
  { value: "gadi_petrol_safar", label: "🚗 Gadi, Petrol, Public Transport & Safar" },
  { value: "dawai_ilaaj", label: "💊 Dawai, Ilaaj, Insurance & Swasthya" },
  { value: "shiksha_fees", label: "📚 Shiksha (College Fees, Tuition, Books)" },
  { value: "kapde_lifestyle", label: "👕 Kapde, Jootey, Gym & Lifestyle" },
  { value: "recharge_subscription", label: "📲 Recharge, Subscription & Internet" },
  { value: "tyohar_uphaar", label: "🎁 Tyohar, Shagun & Gifting" },
  { value: "ghar_sudhar", label: "🔧 Ghar & tools (Repair, Maintenance)" },
  { value: "enjoyment", label: "🎬 Enjoyment (Movies, Trips, Teerth Yatra)" },
  { value: "other_kharche", label: "☕ Other Kharche (Parking, Snacks, Misc)" }
];
